'use strict';

angular.module('internal.services')
    .controller('InternalServiceUsersLongevities', ['$scope', 'ServiceUserLongevities', function ($scope, ServiceUserLongevities) {
        $scope.resetService();
        $scope.isLongevitiesOpen = true;

        ServiceUserLongevities.get({ service_id: $scope.serviceID }).then(function (data) {
            $scope.service_user_longevities = data;
        })

        $scope.link = {
            state: 'internal.licensing.service.users.longevity',
            params: [
                {
                    name: 'longevityID',
                    field: 'id'
                },
                {
                    name: 'longevity',
                    field: ''
                }
            ]
        };

        $scope.columns = [
            {
                label: 'User',
                field: 'user_nameandnumber',
                type: 'text'
            },
            {
                label: 'Longevity Date ',
                field: 'longevity_date',
                type: 'date'
            },
            {
                label: 'Credit Value',
                field: 'credit_value',
                type: 'decimal'
            },
            {
                label: 'Redeemed',
                field: 'redeemed',
                type: 'yesno'
            },
            {
                label: 'Approved By',
                field: 'approved_by',
                type: 'text'
            },
            {
                label: 'Approved On ',
                field: 'approved_on',
                type: 'datetime'
            }
        ]
    }])
;